// extracted by mini-css-extract-plugin
export default {"ShareButton":"ShareButton-module__ShareButton--YYxtW","Text":"ShareButton-module__Text--rkufO"};